export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="lgog" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FE730D" />
          <stop offset="1" stopColor="#FFB700" />
        </linearGradient>
      </defs>
      <circle
        cx="30"
        cy="27"
        r="15"
        fill="none"
        stroke="url(#lgog)"
        strokeWidth="5.5"
        strokeDasharray="78 18"
        strokeLinecap="round"
        transform="rotate(-40 30 27)"
      />
      <path
        d="M30 17.5a9.5 9.5 0 0 1 9.5 9.5c0 6.2-5.7 11.4-9.5 14.7-3.8-3.3-9.5-8.5-9.5-14.7A9.5 9.5 0 0 1 30 17.5z"
        fill="url(#lgog)"
      />
      <circle cx="30" cy="27" r="3.4" fill="#0B0F19" />
      <path d="M14 51 L36 43.5 L28.5 56 Z" fill="url(#lgog)" />
    </svg>
  );
}

export default function Logo({ className = "" }) {
  return (
    <img
      src="/logo-horizontal.png"
      alt="OFF360"
      width={180}
      height={36}
      data-testid="off360-logo"
      className={`h-8 w-auto shrink-0 sm:h-9 ${className}`}
    />
  );
}
